(function () {
  var ROOT = '.yumwoof-landing-page[data-detached-slug="memorial-day-sale"]';
  var FAQ_ICON_PLUS =
    'M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4';
  var FAQ_ICON_MINUS = 'M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5';

  function initFaq() {
    var controllers = [];
    document.querySelectorAll(ROOT + ' [data-replo-collapsible]').forEach(function (item) {
      var trigger = item.querySelector('[role="button"][aria-controls]');
      if (!trigger) return;
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : item.querySelector('[hidden]');
      if (!panel) return;
      var iconPath = trigger.querySelector('svg path');
      function setOpen(open) {
        item.setAttribute('data-state', open ? 'open' : 'closed');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        if (iconPath) iconPath.setAttribute('d', open ? FAQ_ICON_MINUS : FAQ_ICON_PLUS);
      }
      controllers.push({ item: item, setOpen: setOpen });
      function toggle() {
        var opening = item.getAttribute('data-state') !== 'open';
        if (opening) {
          controllers.forEach(function (c) {
            if (c.item !== item) c.setOpen(false);
          });
        }
        setOpen(opening);
      }
      trigger.addEventListener('click', function (e) { e.preventDefault(); toggle(); });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  function boot() {
    initFaq();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
